var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"mb-2 px-1 py-0 mr-1",attrs:{"variant":"primary","size":"lg","title":"Download Import"},on:{"click":_vm.downloadFile}},[_c('i',{staticClass:"fa fa-download"}),(!_vm.isAction)?_c('p',[_vm._v("Download Import File")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }